import styles from './header-search.module.scss';
import { useContext, useState } from 'react';
import { ContactListContext, GetCurrentCompany, SelectedContactUpdateContext } from '../customer-context/customer-context';
import { useNavigate } from "react-router-dom";
import { CompanySearch } from '@frontend-workspace/react-shared-lib';


/* eslint-disable-next-line */
export interface HeaderSearchProps { }

export function HeaderSearch(props: HeaderSearchProps) {
  const currentCompany = GetCurrentCompany();
  const navigate = useNavigate();
  const companyList = useContext(ContactListContext);
  const setSelectedCompany = useContext(SelectedContactUpdateContext);

  const handleCompanySelected = (number: string) => {
    const newCompany = companyList.find(c => c.number === number);
    const pathName = window.location.pathname;
    const pathParts = pathName.split('/');

    if (newCompany) {
      if (currentCompany) pathParts[2] = newCompany.number;
      else pathParts.splice(2, 0, newCompany.number);
    }
    else if (!number) {
      pathParts.splice(2, 1);
    }
    setSelectedCompany(newCompany);
    navigate(pathParts.join("/"));
  }
  return (
    <CompanySearch
      selectedCompanyNumber={currentCompany?.number}
      companyList={companyList}
      onChange={handleCompanySelected}
    />
  );
}

export default HeaderSearch;